<template>
    <div class='portal-body'>
        <div>
            <img src="../../../static/banner.png">
        </div>
        <div class='area'>
            <my-area v-for='(area,index) in areaList' :key='index' :titleData='area' :areaData='areaData[area.model]'></my-area>
        </div>

    </div>
</template>
<style>
    @import './index.scss';
</style>
<script>
    import Area from './component/my-area.vue'
    import navList from '../../data/_list.json'
    import LingGanCaiJi from '../../data/linggancaiji.json'
    import JieMianJiaoHu from '../../data/jiemianjiaohu.json'
    import SheJiGuiFan from '../../data/shejiguifan.json'
    import ZaiXianGongJu from '../../data/zaixiangongju.json'
    import Icon from '../../data/icon.json'
    import SheJiSuCai from '../../data/shejisucai.json'
    import TuKuSuCai from '../../data/tukusucai.json'
    import YanSeDaPei from '../../data/yansedapei.json'
    import ZiTiZiXing from '../../data/zitizixing.json'
    import SheJiTuanDui from '../../data/shejituandui.json'
    export default {
        components: {
            'my-area': Area
        },
        data() {
            return {
                areaList: navList,
                areaData: {
                    LingGanCaiJi,
                    JieMianJiaoHu,
                    SheJiGuiFan,
                    ZaiXianGongJu,
                    Icon,
                    SheJiSuCai,
                    TuKuSuCai,
                    YanSeDaPei,
                    ZiTiZiXing,
                    SheJiTuanDui
                }
            }
        }
    }

</script>


// WEBPACK FOOTER //
// index.vue?75275ea0